import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
  showIcon?: boolean;
}
export function Button({
  children,
  className = '',
  showIcon = true,
  ...props
}: ButtonProps) {
  return <button className={`
        group relative inline-flex items-center justify-center gap-3 
        bg-emerald-600 hover:bg-emerald-700 text-white 
        font-bold text-xl py-5 px-8 rounded-xl shadow-lg 
        transition-all duration-300 ease-out transform hover:scale-[1.02]
        focus:outline-none focus:ring-4 focus:ring-emerald-500/50
        ${className}
      `} {...props} data-id="element-102">
      {showIcon && <ShieldCheckIcon className="w-6 h-6" aria-hidden="true" data-id="element-103" />}
      <span data-id="element-104">{children}</span>
    </button>;
}